import { InjectionKey } from 'vue'

import { useStreamVolume } from '@/entities/webrtc'

import { Contact } from '@/shared/types/api'


type ToggleLayout = {
  setActiveCallId: (id: string, streamId?: MediaStream['id']) => void;
}

export const toggleLayoutKey: InjectionKey<ToggleLayout> = Symbol('toggle-layout')

export const VOICE_ACTIVE_THRESHOLD = 5
export const VOICE_LEVEL_MAX = 40
export const REMOTE_VOICE_LEVEL_GAIN = 1.2

export function getVoiceLevel (number: Contact['internalNumber'] | string) {
  const { getVolumeById } = useStreamVolume()
  const volume = getVolumeById(number) ?? 0
  if (volume <= VOICE_ACTIVE_THRESHOLD) {
    return 0
  }

  return Math.min(1, (volume - VOICE_ACTIVE_THRESHOLD) / (VOICE_LEVEL_MAX - VOICE_ACTIVE_THRESHOLD))
}

export function isVoiceActive (number: Contact['internalNumber'] | string) {
  return getVoiceLevel(number) > 0
}
